export default __webpack_public_path__ + "static/media/ninaspeleando.587da735.png";